import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { name: "首页", path: "/" },
  { name: "分类浏览", path: "/category/全部" },
  { name: "排行榜", path: "/#ranking", hash: true },
  { name: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="text-xl md:text-2xl font-heading font-bold text-primary-500">
              po18
            </span>
            <span className="hidden sm:inline text-sm md:text-base font-body text-foreground-700">
              脸红心跳
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) =>
              link.hash ? (
                <a
                  key={link.path}
                  href={link.path}
                  className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                    isActive(link.path)
                      ? "text-primary-500"
                      : "text-foreground-600 hover:text-primary-500"
                  }`}
                >
                  {link.name}
                </a>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                    isActive(link.path)
                      ? "text-primary-500"
                      : "text-foreground-600 hover:text-primary-500"
                  }`}
                >
                  {link.name}
                </Link>
              )
            )}
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i
              className={`text-xl ${
                mobileMenuOpen ? "ri-close-line" : "ri-menu-line"
              }`}
            ></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            {navLinks.map((link) =>
              link.hash ? (
                <a
                  key={link.path}
                  href={link.path}
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                    isActive(link.path)
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-600 hover:bg-background-100"
                  }`}
                >
                  {link.name}
                </a>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                    isActive(link.path)
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-600 hover:bg-background-100"
                  }`}
                >
                  {link.name}
                </Link>
              )
            )}
          </div>
        </div>
      )}
    </nav>
  );
}